"use strict";

var _regeneratorRuntime = require("D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = downscaleImageToDataURLUsingBrowser;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function keepAspectRatio(width, height, maxWidth, maxHeight) {
  if (width < maxWidth && height < maxHeight) {
    // Photo is smaller than both maximum dimensions, take it as-is
    return {
      height: height,
      width: width
    };
  }

  var aspectRatio = width / height;

  if (aspectRatio > maxWidth / maxHeight) {
    // Photo is wider than maximum dimension, downscale it based on maxWidth.
    return {
      height: maxWidth / aspectRatio,
      width: maxWidth
    };
  } // Photo is taller than maximum dimension, downscale it based on maxHeight.


  return {
    height: maxHeight,
    width: maxHeight * aspectRatio
  };
}

function createCanvas(width, height) {
  var canvas = document.createElement('canvas');
  canvas.height = height;
  canvas.width = width;
  return canvas;
}

function loadImageFromBlob(blob) {
  var blobURL = URL.createObjectURL(blob);
  return new Promise(function (resolve, reject) {
    var image = document.createElement('img');
    image.addEventListener('error', function (_ref) {
      var error = _ref.error;
      return reject(error);
    });
    image.addEventListener('load', function () {
      return resolve(image);
    });
    image.setAttribute('src', blobURL);
  }).finally(function () {
    URL.revokeObjectURL(blobURL);
  });
}

function downscaleImageToDataURLUsingBrowser(_x, _x2, _x3, _x4, _x5) {
  return _downscaleImageToDataURLUsingBrowser.apply(this, arguments);
}

function _downscaleImageToDataURLUsingBrowser() {
  _downscaleImageToDataURLUsingBrowser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blob, maxWidth, maxHeight, type, quality) {
    var image, _keepAspectRatio, height, width, canvas, context;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadImageFromBlob(blob);

          case 2:
            image = _context.sent;
            _keepAspectRatio = keepAspectRatio(image.width, image.height, maxWidth, maxHeight), height = _keepAspectRatio.height, width = _keepAspectRatio.width;
            canvas = createCanvas(width, height);
            context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, width, height);
            return _context.abrupt("return", canvas.toDataURL(type, quality));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _downscaleImageToDataURLUsingBrowser.apply(this, arguments);
}